<template>
  <nav class="nav__menu" v-touch:swipe.left="close" v-touch:tap="close">
    <div class="nav__menu-profile">
      <img class="avatar" src="../assets/icons/menu/avatar.png" alt="avatar" />
      <h1>John Morris</h1>
      <p class="blue">View Profile</p>
    </div>
    <section>
      <img src="../assets/icons/menu/family.png" alt="my family icon" />
      <span>My Family</span>
    </section>
    <section>
      <img src="../assets/icons/menu/plans.png" alt="plans icon" />
      <span>Plans</span>
    </section>
    <section>
      <img src="../assets/icons/menu/gear.png" alt="settings icon" />
      <span>Settings</span>
    </section>
    <section class="log-out">
      <img src="../assets/icons/menu/log-out.png" alt="log out icon" />
      <span>Log Out</span>
    </section>
  </nav>
</template>

<script>
export default {
  name: "Menu",
  props: {
    close: Function
  }
};
</script>

<style lang="scss" scoped>
.nav__menu {
  color: #fff;
  background-color: var(--black);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: left;
  text-align: left;
  height: 100%;
  width: 50%;
  padding: 2rem;
  z-index: 10;
  transform: translateX(-100%);
  transition: all 500ms ease-in-out;

  .exit {
    text-align: right;
    font-size: 1.2rem;
  }

  &-profile {
    padding: 1rem 0;
  }

  .blue {
    color: #2b94ff;
  }
  h1 {
    margin: 0;
    font-size: 1.75rem;
  }
  p {
    margin: 0;
  }

  @media only screen and (min-height: 800px) {
    p,
    span {
      font-size: 1.25rem;
    }
  }

  section {
    display: flex;
    align-content: space-between;
    align-items: center;
    padding: 10% 10% 10% 0;

    img {
      width: 30px;
    }

    span {
      margin-left: 1.5rem;
    }
  }

  .avatar {
    width: 70px;
    height: auto;
    margin-bottom: 5%;
  }

  .active & {
    transform: translateX(0%);
  }
}
</style>
